var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',{staticClass:"main d-flex justify-content-center w-100"},[_c('div',{staticClass:"container d-flex flex-column"},[_c('child')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }